import { ActionMap, createMsg } from 'src/core/engine/actionCreators';
import { QuoteDataCartItemInterface } from 'swagger/ts/Definitions';
import { DataStatus, Message, MessageType } from 'src/core/engine/types';
import { bundleAdd } from 'src/components/BundleProduct/feature/epics/bundleAdd.epic';
import { map, Observable } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { LOCATION_CHANGE } from 'src/core/engine/router/router.register';

export const NAME = 'bundle';

export type Messages = {
    ['Bundle.Add']: QuoteDataCartItemInterface;
    ['Bundle.AddSuccess']: string[];
    ['Bundle.AddError']: string;

    ['Bundle.Reset']: undefined;
};

export type BundleState = {
    status: DataStatus;
    messages: Message[];
    itemIds: string[];
};

const initialState = {
    status: DataStatus.Idle,
    messages: [],
    itemIds: [],
};

export function bundleRegister() {
    return {
        epics: [
            bundleAdd,
            /**
             * Reset the state on page nav
             * @param action$
             */
            (action$: Observable<any>) =>
                action$.pipe(
                    ofType(LOCATION_CHANGE),
                    map(() => BundleMsg('Bundle.Reset')),
                ),
        ],
        reducers: {
            [NAME]: function (state: BundleState = initialState, action: BundleActions): BundleState {
                switch (action.type) {
                    case 'Bundle.Reset': {
                        return { ...initialState };
                    }
                    case 'Bundle.Add': {
                        return {
                            ...state,
                            messages: [],
                            itemIds: [],
                            status: DataStatus.Pending,
                        };
                    }
                    case 'Bundle.AddError': {
                        return {
                            ...state,
                            messages: [{ type: MessageType.Error, text: action.payload }],
                            itemIds: [],
                            status: DataStatus.Error,
                        };
                    }
                    case 'Bundle.AddSuccess': {
                        return {
                            ...state,
                            messages: [],
                            itemIds: action.payload,
                            status: DataStatus.Success,
                        };
                    }
                    default:
                        return state;
                }
            },
        },
        name: NAME,
    };
}

export const BundleMsg = createMsg<Messages>();
export type TypeMap = ActionMap<Messages>;
export type BundleActions = TypeMap[keyof TypeMap];
export type AppendState<T = Record<string, unknown>> = T & { bundle: BundleState };
